
import { Box, Collapse, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Close as CloseIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { Button, IconButton, Link } from 'evee-ui-common/components/base';
import { Region } from 'evee-ui-common/enums';
import { getHomeUrl } from 'evee-ui-common/utils';

import styles from './styles';

const HeaderNotification = ({ open, classes, onClose }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const closeIconJsx = <CloseIcon fontSize="small" className={classes.closeIcon} />;

  const getOfferText = () => {
    if (isMobile) {
      return '⚡ Unlock $100 credit – rent or refer friends to earn!';
    }

    return (
      <>
        <b>⚡ Unlock $100 credit </b> - rent or refer friends to earn!
      </>
    );
  };

  return (
    <Collapse in={open} className={classes.container}>
      <Grid container className={classes.gridContainer}>
        <Grid item xs={isMobile ? false : 1} />

        <Grid item xs>
          <Box display="flex" alignItems="center" justifyContent={isMobile ? 'left' : 'center'}>
            <Typography color="secondary" style={{ padding: isMobile ? '16px' : '4px 16px' }}>
              {getOfferText()}
              {isMobile && (
                <>
                  {' '}
                  &nbsp;
                  <Link
                    href={`${getHomeUrl(Region.australia)}/pages/rewards`}
                    color="inherit"
                    underline="none"
                    target="_blank"
                    style={{ fontWeight: '400' }}
                  >
                    <b>Learn more →</b>
                  </Link>
                </>
              )}
            </Typography>
            {!isMobile && (
              <Button
                size="small"
                color="secondary"
                type="contained"
                text="Learn more"
                href={`${getHomeUrl(Region.australia)}/pages/rewards`}
                target="_blank"
              />
            )}
          </Box>
        </Grid>

        <Grid item xs={1}>
          <Box display="flex" justifyContent="flex-end" paddingRight="4px">
            <IconButton color="secondary" icon={closeIconJsx} className={classes.closeButton} onClick={onClose} />
          </Box>
        </Grid>
      </Grid>
    </Collapse>
  );
};

HeaderNotification.propTypes = {
  open: PropTypes.bool,
  classes: PropTypes.shape({
    gridContainer: PropTypes.string.isRequired,
    container: PropTypes.string.isRequired,
    closeIcon: PropTypes.string.isRequired,
    countdown: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func,
};

HeaderNotification.defaultProps = {
  open: false,
  onClose: () => {},
};

export default withStyles(styles)(HeaderNotification);
